import "./ChatPanel.css";

type Props = {
    chatNode: JSX.Element;
    phaseLabel: string; // es: "Fase 2 di 3"
    phaseTitle: string; // es: "La Moodboard"
    onMenu?: () => void;
    onClose?: () => void;

    onBack?: () => void;
    backDisabled?: boolean;   // ✅ nuova prop

};

export const ChatPanel = ({ chatNode, phaseLabel, phaseTitle, onMenu, onClose,
                              onBack,
                              backDisabled }: Props) => {
    return (
        <main className="chatArea glassCard">
            <div className="chatHeader">
                <div className="chatHeaderLeft">
                    <span className="chatPhase">{phaseLabel}</span>
                    <span className="chatTitle">{phaseTitle}</span>
                </div>


                <div className="chatHeaderRight">
                    <button
                        className="chatBackBtn"
                        onClick={onBack}
                        disabled={backDisabled}
                        aria-label="Torna alla fase precedente"
                        type="button"
                    >
                        ← Torna alla fase precedente
                    </button>
                </div>
            </div>

            <div className="chatBody">
                {chatNode}
            </div>
        </main>
    );
};
